<template>
    <el-col v-loading="loading" :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <transition name="el-fade-in-linear">
                <div v-if="documentos.length > 0" style="width: 100%; max-width: 550px;">
                    <div style="display:contents;">
                        <div class="clearfix">
                            <h2 v-if="mode == 'seleccionfirmante'">Pincha sobre cada uno de los receptores para establecer una posición de firma</h2>
                           <h2 v-if="mode != 'seleccionfirmante'">Pincha sobre el documento para establecer una posición de firma</h2>
                            <div
                                style="display: flex; color: #727272; padding: 10px; border-radius: 5px; width: 100%; align-items: center;">
                                <img style="height: 30px; margin-right: 10px;" src="@/assets/acuerdo.png" />
                                <h4 style="text-overflow: ellipsis; overflow: hidden;">{{
                                    files[documentoActual].file.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="container text-center">
                            <div class="row">
                                <div class="col-4">
                                    <div id="contenedor_documentos">
                                        <div id="contenedor_0"
                                            style="float:left; display: flex; flex-direction: column; align-items: center; width: 100%; padding: 10px; border-radius: 10px;">
                                            <div v-show="mode == 'seleccioncoordenadas'">
                                                <div class="navigation_controls"
                                                    style="width: 100%; margin-bottom:20px; display: flex; justify-content: space-between; align-items: center;">
                                                    <el-button
                                                        @click="recalcularPagina(--documentos[documentoActual].currentPage);"
                                                        type="warning" circle
                                                        :disabled="documentos[documentoActual].currentPage == 1"><font-awesome-icon
                                                            :icon="['fas', 'angle-left']" /></el-button>
                                                    <span id="span_pagina" style="color:#727272;"><b>Página <span
                                                                class="pagina_1">{{
                                                                    documentos[documentoActual].currentPage }}</span>
                                                            de <span>{{
                                                                documentos[documentoActual].pdf._pdfInfo.numPages
                                                            }}</span> </b></span>
                                                    <el-button
                                                        @click="recalcularPagina(++documentos[documentoActual].currentPage);"
                                                        type="warning" circle
                                                        :disabled="documentos[documentoActual].currentPage == documentos[documentoActual].pdf._pdfInfo.numPages"><font-awesome-icon
                                                            :icon="['fas', 'angle-right']" /></el-button>
                                                </div>
                                                <div class="contenedor_canvas">
                                                    <canvas style="display:none" class="canvas_0"></canvas>
                                                </div>
                                                <div class="contenedor_imagenes" style="position:relative;">
                                                    <div class="contenedor_firmas">
                                                        <div class='firmas'
                                                            style="background-color:#409eff;display: none;height: 25px;width: 70px;position: absolute; color: white; text-align:center;">
                                                            {{ numFirmante + 1 }}
                                                        </div>
                                                        <div :key="`firmante${index}`"
                                                            v-for="(firmante, index) in documentos[documentoActual].firmantes.filter((fir) => { return fir.eventClickImg })"
                                                            :class='`firmas${firmante.id}`'
                                                            :style="`background-color:${colores[index] ?? '#636e72'};height: 25px;width: 70px;position: absolute; color:white; text-align: center; top: ${firmante.eventClickImg.y}px; left: ${firmante.eventClickImg.x}px`">
                                                            {{ firmante.ordenFirma }}
                                                        </div>
                                                    </div>
                                                    <div class="contenedor_firmas2"
                                                        @mousemove="seguirRaton($event, documentos[documentoActual].pages[documentos[documentoActual].currentPage - 1])"
                                                        @click="clickCoordinatesPage($event, documentos[documentoActual].pages[documentos[documentoActual].currentPage - 1])">
                                                        <div class='firmas2'
                                                            style="background-color:rgb(64 158 255 / 40%);display: none;height: 25px;width: 70px;position: absolute;">
                                                        </div>
                                                    </div>
                                                    <div class="imagenes">
                                                        <template v-if="documentos[documentoActual].pages.length > 0">
                                                            <el-collapse-transition>
                                                                <img ref="img_0" id="img_0" class="img_0"
                                                                    @mousemove="seguirRaton($event, documentos[documentoActual].pages[documentos[documentoActual].currentPage - 1])"
                                                                    @click="clickCoordinatesPage($event, documentos[documentoActual].pages[documentos[documentoActual].currentPage - 1])"
                                                                    style="border:3px solid darkgray; border-radius:5px; height: 500px"
                                                                    :src="documentos[documentoActual].pages[documentos[documentoActual].currentPage - 1].data">
                                                            </el-collapse-transition>
                                                        </template>
                                                    </div>
                                                    <el-button
                                                        :disabled="!documentos[documentoActual].firmantes[numFirmante] || !documentos[documentoActual].firmantes[numFirmante].eventClickImg"
                                                        @click="mode = 'seleccionfirmante';"
                                                        style="width: 100%; margin-top: 10px;" type="warning">Guardar
                                                        posición
                                                    </el-button>
                                                </div>
                                            </div>
                                            <div style="width: 100%" v-show="mode == 'seleccionfirmante'">
                                                <div
                                                    style="display: flex; flex-direction: column; margin-bottom: 20px; color: #727272; padding: 5px; border-radius: 5px; width: 100%;">
                                                    <div v-for="(empleado, index) in filteredEmpleados" :key="empleado">
                                                        <p style="cursor: pointer;"
                                                            @click="documentos[documentoActual].firmantes[index] = { ...empleado }; mode = 'seleccioncoordenadas'; documentos[documentoActual].firmantes[index].ordenFirma = index + 1; numFirmante = index">
                                                            <i :style="`color: ${documentos[documentoActual].firmantes.find((firmante) => { return firmante && firmante.email == empleado.email }) ? '#2ed573' : '#ff4757'};`"
                                                                class="fa-solid fa-signature"></i> {{ empleado.nombre }}
                                                        </p>
                                                    </div>

                                                </div>
                                                <el-button
                                                    @click="documentos[documentoActual].firmantes = []; numFirmante = 1">Restablecer
                                                    posiciones</el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div style="display:flex; align-items: center; margin-top: 20px;">
                <el-button :type="this.working == 'documentos' ? 'primary' : 'warning'" icon="Back" @click="documentoActual > 0 ? documentoActual-- : $router.go(-1)"
                    :disabled="leftDisabled" />
                <b style="margin: 10px; font-size: 20px; color:#727272;">{{
                    documentoActual + 1 }} / {{
        documentos.length
    }}</b>
                <el-button :type="this.working == 'documentos' ? 'primary' : 'warning'" icon="Right" :disabled="pasarSiguienteDocumento"
                    @click="documentoActual + 1 == documentos.length ? $router.push('/confirm') : documentoActual++" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'SeleccionPosicion',
    watch: {
        mode() {
            let firmas = "firmas";

            firmas = document.querySelector(
                `.contenedor_imagenes .contenedor_firmas .firmas`
            );
            firmas.style.display = 'none';
        },
        documentoActual() {
            this.numFirmante = 1;
        }
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            documentoActual: 0,
            mode: 'seleccionfirmante',
            numFirmante: 1,
            colores: [
                "#74b9ff",
                "#a29bfe",
                "#55efc4",
                "#81ecec",
                "#ff9ff3",
                "#fd79a8",
                "#ff7675",
                "#b2bec3",
                "#fab1a0",
                "#5352ed"
            ]
        }
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'documentos'
        ]),
        filteredEmpleados() {
            return this.receptores.filter(receptor =>
                receptor.tipo == 'empleado' && (receptor.selected || receptor.disabled)
            );
        },
        filteredEmpleadosFirmantes() {
            return this.documentos[this.documentoActual].firmantes;
        },
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if (this.files.length == 0) {
                return true;
            }
            return false;
        },
        pasarSiguienteDocumento() {
            if (this.documentos[this.documentoActual].firmantes.length != this.filteredEmpleados.length || this.mode != 'seleccionfirmante') {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setDocumentos',
        ]),
        ocultarRaton() {
            document.querySelector(`.contenedor_imagenes .contenedor_firmas2 .firmas2`).style.display = 'none'
        },
        seguirRaton(e) {
            let elemento = this.$refs[`img_0`];
            let bounds = elemento.getBoundingClientRect()
            var left = bounds.left
            var top = bounds.top
            var x = e.pageX - left
            var y = e.pageY - top
            var cw = elemento.clientWidth
            var ch = elemento.clientHeight
            let firmas = "firmas2";

            firmas = document.querySelector(
                `.contenedor_imagenes .contenedor_firmas2 .firmas2`
            );
            if (y < ch - 25 && x < cw - 70) {
                firmas.style.backgroundColor = "rgb(64 158 255 / 40%)";
                (firmas.style.display = "block");
                (firmas.style.top = `${y}px`);
                (firmas.style.left = `${x}px`);
                (firmas.style.zIndex = "100");
            } else {
                firmas.style.backgroundColor = "#e74c3c63";
            }
        },
        recalcularPagina(pagina) {
            let firmas = document.querySelector(
                `.contenedor_imagenes .contenedor_firmas .firmas`
            );
            document.querySelector(`.contenedor_imagenes .contenedor_firmas2 .firmas2`).style.display = "none";
            if (this.documentos[this.documentoActual].eventClickImg != null && this.documentos[this.documentoActual].eventClickImg.valid && pagina == this.documentos[this.documentoActual].eventClickImg.page.page) {
                firmas.style.display = "block";
                (firmas.style.top = `${this.documentos[this.documentoActual].eventClickImg.y}px`);
                (firmas.style.left = `${this.documentos[this.documentoActual].eventClickImg.x}px`);
                (firmas.style.zIndex = "100");
                document.getElementById('img_0').style.border = "3px solid rgb(64, 158, 255)"
            } else {
                firmas.style.display = "none";
                document.getElementById('img_0').style.border = "3px solid darkgray"
            }
        },
        clickCoordinatesPage(e, page) {
            let elemento = this.$refs[`img_0`];
            let bounds = elemento.getBoundingClientRect()
            var left = bounds.left
            var top = bounds.top
            var x = e.pageX - left
            var y = e.pageY - top
            var cw = elemento.clientWidth
            var ch = elemento.clientHeight
            var iw = elemento.naturalWidth
            var ih = elemento.naturalHeight
            var px = x / cw * iw * 0.35
            var py = y / ch * ih * 0.35
            console.log('X' + px)
            console.log('Y' + py)
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg = {};
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.px = px
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.py = py
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.x = x
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.y = y
            this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.page = page

            let firmas = "firmas";

            firmas = document.querySelector(
                `.contenedor_imagenes .contenedor_firmas .firmas`
            );
            if (y < ch - 25 && x < cw - 70) {
                (firmas.style.display = "block");
                (firmas.style.top = `${y}px`);
                (firmas.style.left = `${x}px`);
                (firmas.style.zIndex = "100");
                document.getElementById('img_0').style.border = "3px solid rgb(64, 158, 255)"
                this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.valid = true;
            } else {
                document.getElementById('img_0').style.border = "3px solid red"
                this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg.valid = false;
                this.documentos[this.documentoActual].firmantes[this.numFirmante].eventClickImg = null;
            }
        },
        cogerCoordenadas(e) {
            //recorrer solo todas las imagens
            // let indice = documentos.length - 1;
            // let documento = documentos[indice];
            // let contador_firma = 1;

            let imagenWidth = e.currentTarget.clientWidth
            let imagenHeight = e.currentTarget.clientHeight

            this.coordenadas.cordenada_X = (imagenWidth - e.layerX) - document.querySelector('.contenedor_firmas > div').clientWidth
            this.coordenadas.cordenada_Y = (imagenHeight - e.layerY) - document.querySelector('.contenedor_firmas > div').clientHeight

            if (this.coordenadas.cordenada_X < 3 || this.coordenadas.cordenada_Y < 3) {
                if (this.coordenadas.rectanguloFirma == 1) {
                    this.$message('Posición de firma incorrecta');
                    this.coordenadas.rectanguloFirma++
                }

                e.currentTarget.style.border = "3px solid red"
            }
            else {
                e.currentTarget.style.border = "3px solid rgb(64, 158, 255)"

                for (var j = 1; j <= this.coordenadas.firmante; j++) {
                    //for (var i = 1; i <= documento.pages.length; i++) {
                    //document.querySelector(`#contenedor_documentos #contenedor_0 .contenedor_imagenes .imagenes .img${i}`).addEventListener("click", (e) => {

                    e.preventDefault();
                    e.currentTarget.getBoundingClientRect();

                    this.coordenadas.x = e.layerX;
                    this.coordenadas.y = e.layerY;

                    // let contenedor_id = Number(
                    //   e.currentTarget.parentElement.parentElement.id.replace(
                    //     "contenedor_",
                    //     ""
                    //   )
                    // );

                    let firmas = "firmas";

                    firmas = document.querySelector(
                        `.contenedor_imagenes .contenedor_firmas .firmas`
                    );

                    //let display = (firmas.style.display = "block");
                    let top = (firmas.style.top = `${this.coordenadas.y}px`);
                    let left = (firmas.style.left = `${this.coordenadas.x}px`);
                    let zIndex = (firmas.style.zIndex = "100");
                    // let height = (firmas.style.height = `50px`);
                    // let width = (firmas.style.width = `100px`);
                    //let position = (firmas.style.position = "absolute");
                    // var r = Math.floor(Math.random() * 256);
                    // var g = Math.floor(Math.random() * 256);
                    // var b = Math.floor(Math.random() * 256);
                    // var bgColor = "rgb(" + r + "," + g + "," + b + ")";

                    //let backgroundColor = (firmas.style.backgroundColor = bgColor);
                    let coord_x = this.coordenadas.x - 20;
                    let coord_y = this.coordenadas.y - 120;

                    //let arrayFirma = "guardarfirma"+j
                    this.coordenadas.guardarfirma.push({
                        //display: display,
                        top: top,
                        left: left,
                        zIndex: zIndex,
                        // height: height,
                        // width: width,
                        // position: position,
                        // backgroundColor: backgroundColor,
                        x: coord_x,
                        y: coord_y,
                        pagina: this.documentos[this.documentoActual].currentPage,
                    });
                    //}
                    //});
                }
            }
        },
        guardarDatos(valor) {
            this.documentos[this.documentoActual].data.valid = 'none';
            setTimeout(() => {
                this.documentos[this.documentoActual].data.valid = valor;
            }, 300);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}

.shadow {
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}</style>